import 'whatwg-fetch';

function successHandler(response) {
  if (response.ok)
    return response.json();

  let error = new Error(response.statusText);
  error.response = response;

  throw error;
}

function makeCatchHandler(catchCallback) {
  return error => {
    catchCallback(error);

    if (!error.response)
      return;

    console.error(error.response.statusText);
  };
}

class ApiService {
  constructor() {}

  /**
   * Returns a new `Headers` object with default headers.
   *
   * @method getHeaders
   */
  getHeaders() {
    const headers = new Headers();

    headers.append('Content-Type', 'application/json');

    return headers;
  }

  /**
   * Returns a promise for a GET request to the given `url`.
   *
   * @param {string} url - Target url for request.
   * @method get
   */
  get(url, catchCallback) {
    const headers = this.getHeaders();

    const token = localStorage.getItem('token');
    headers.append('Authorization', `JWT ${token}`);

    return fetch(url, {
      headers: headers,
    }).then(successHandler).catch(makeCatchHandler(catchCallback));
  }

  /**
   * Returns a promise for a POST request to the given `url` with the given
   * `data`.
   *
   * @param {string} url - Target url for request.
   * @param {Object} data - Data to post.
   * @method post
   */
  post(url, data, catchCallback) {
    const headers = this.getHeaders();

    return fetch(url, {
      headers: headers,
      method: 'POST',
      mode: 'cors',
      cache: 'default',
      body: JSON.stringify(data),
    }).then(successHandler).catch(makeCatchHandler(catchCallback));
  }
}

const apiService = new ApiService();
export default apiService;



// WEBPACK FOOTER //
// ./src/client/services/api-service.js